import { useMutation, useQueryClient } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function useUpdateCompanyDetails(closeModal) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.COMPANY_DETAILS,
        data
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        SuccessToast({ text: data.message });
        queryClient.invalidateQueries('get-organisation-data');
        queryClient.invalidateQueries('admin-company-details');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
